import useReviewsStatisticsStore from '~/modules/reviews/stores/useReviewsStatisticsStore';
import { passStoreThroughComposableFactory } from '~/utils/passStoreThroughComposableFactory';

const useReviewsStatistics = () => passStoreThroughComposableFactory(useReviewsStatisticsStore());

export default useReviewsStatistics;
